import "@/assets/fonts/fonts.css";
import { ensureMockAuthSession } from "@/features/auth/auth.mock";
import { enableMocking } from "@/shared/lib/msw";
import { queryClient } from "@/shared/lib/queryClient";
import { router } from "@/shared/lib/router";
import { initTheme } from "@/shared/stores/theme.store";
import "@/shared/styles/global.css";
import en from "@/locales/en.json";
import ko from "@/locales/ko.json";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initReactI18next } from "react-i18next";

initTheme();
ensureMockAuthSession();

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			ko: { translation: ko },
			en: { translation: en },
		},
		debug: false,
		fallbackLng: "ko",
		supportedLngs: ["ko", "en"],
		interpolation: { escapeValue: false },
	});

enableMocking().then(() => {
	createRoot(document.getElementById("root")!).render(
		<StrictMode>
			<QueryClientProvider client={queryClient}>
				<RouterProvider router={router} />
			</QueryClientProvider>
		</StrictMode>,
	);
});
